import { render, staticRenderFns } from "./UkStep2.vue?vue&type=template&id=3c6a197c"
import script from "./UkStep2.vue?vue&type=script&lang=js"
export * from "./UkStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports